import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { BRAND_PROFILES_LIST, BRAND_PROFILES, BRAND_TITLES } from 'constants';
import { MainHeader, PageLayout, Avatar, Drawer, Button } from 'sharedComponents';
import { NeimanMarcusSignatureIcon, BergdorfGoodmanSignatureIcon } from 'sharedComponents/Icons';
import { ListItem, List, ListItemText, Icon, Typography } from '@material-ui/core';

const brandToIconMap = {
  [BRAND_PROFILES.NM]: NeimanMarcusSignatureIcon,
  [BRAND_PROFILES.BG]: BergdorfGoodmanSignatureIcon,
};

/**
 * Provides view for logged in user to select AD groups from available one
 * Actual for users with "super user" AD group.
 * More details in https://jira.mynmg.com/browse/OSP-4228
 * UI Mock: https://xd.adobe.com/view/cd061d39-5674-47ce-7868-530058a2bbca-bb37/screen/6d71d434-0b37-4c97-b721-b03aa19013d0/Superuser/
 */
export const SelectActiveADGroup = ({ classes, availableADGroups, onADGroupSelect, logger }) => {
  const [selectedGroup, setSelectedGroup] = React.useState(null);

  // sort availableADGroups alphabetically
  const sortedAvailableADGroups = React.useMemo(
    () => availableADGroups.slice().sort((firstEl, secondEl) => (firstEl.label >= secondEl.label ? 0 : -1)),
    [availableADGroups],
  );

  const handleADGroupSelect = (group) => {
    logger.info(`Super user selected "${group}" AD group`);
    onADGroupSelect(group);
  };

  return (
    <Fragment>
      <MainHeader title="Choose a role to sign in:" titleSize={24} />
      <PageLayout>
        <List>
          {sortedAvailableADGroups.map((group) => (
            <ListItem key={group.name} onClick={() => setSelectedGroup(group)}>
              <Avatar>
                <Icon component={brandToIconMap[group.brand]} fontSize="inherit" />
              </Avatar>
              <ListItemText className={classes.groupName} primary={group.label} />
            </ListItem>
          ))}
        </List>
        <Drawer open={!!selectedGroup} className={classes.drawer}>
          <div className={classes.drawerContainer}>
            <Typography variant="body1">
              You are about to sign in as a {BRAND_TITLES[(selectedGroup?.brand)]} {selectedGroup?.label}.
            </Typography>
            <div className={classes.buttonsContainer}>
              <Button
                label="Cancel"
                onClick={() => setSelectedGroup(null)}
                variant="outlined"
                className={classes.cancelButton}
              />
              <Button label="Continue" onClick={() => handleADGroupSelect(selectedGroup.name)} />
            </div>
          </div>
        </Drawer>
      </PageLayout>
    </Fragment>
  );
};

SelectActiveADGroup.propTypes = {
  onADGroupSelect: PropTypes.func.isRequired,
  availableADGroups: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      brand: PropTypes.oneOf(BRAND_PROFILES_LIST),
    }),
  ).isRequired,
  logger: PropTypes.shape({}),
};

export default SelectActiveADGroup;
